import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface SubtaskTitleStyleProps {
  closed?: boolean
  canEdit?: boolean
  lighter?: boolean
  mobile?: boolean
  isDeleting?: boolean
}
const useStyles = makeStyles<Theme, SubtaskTitleStyleProps>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    cursor: 'pointer',
    height: 'calc(100% + 1rem)',
    width: '95%',
    maxWidth: '95%',
    justifyContent: 'space-between'
  },

  title: {
    display: 'flex',
    flex: 1,
    maxWidth: 'calc(100% - 5rem)',
    overflow: 'hidden',
    alignItems: 'center',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    textDecoration: ({ closed }) => (closed ? 'line-through' : 'none'),
    color: ({ isDeleting }) =>
      isDeleting ? 'lightgrey' : theme.palette.textAlt,

    '& .content': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: 'calc(60vw - 2rem)',

      [theme.breakpoints.down(850)]: {
        maxWidth: 'calc(60vw - 3rem)'
      },

      [theme.breakpoints.down(700)]: {
        maxWidth: '50vw'
      }
    }
  },

  titleBold: {},

  titleLight: {},

  parent: {
    color: theme.palette.primary.main,
    textDecoration: 'underline'
  },

  arrow: {
    margin: '0 0.5rem -4px 0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  count: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',

    '& .count': {
      marginRight: '4px'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.textAlt,

      '& svg': {
        width: '0.75rem',
        height: '0.75rem'
      }
    }
  },

  icon: {
    color: theme.palette.textAlt,
    transform: 'rotate(90deg)'
  },

  input: {
    position: 'relative',
    flex: '1',
    display: 'flex',

    '& input': {
      outline: 'none',
      border: 'none',
      width: '60%',
      maxWidth: 'calc(100% - 9rem)',
      padding: '0',
      fontSize: theme.size.sm,
      fontWeight: ({ lighter }) =>
        lighter ? theme.bold.base : theme.bold.bold,
      background: 'none',
      color: theme.palette.textAlt,
      overflow: 'hidden',
      textDecoration: ({ closed }) => (closed ? 'line-through' : 'none')
    },

    '& .button': {
      position: 'absolute',
      top: '50%',
      right: '5rem',
      minWidth: '45px',
      padding: '0.125rem 0',
      fontSize: theme.size.sm,
      transform: 'translateY(-50%)'
    }
  },

  details: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: '0.5rem'
  },

  edit: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem',
    color: theme.palette.textAlt,
    opacity: '0.35',
    minWidth: '1rem'
  },

  hoverableIconContainer: {
    padding: '0 3px',
    borderRadius: '0.25rem',

    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    }
  },

  isViewing: {
    backgroundColor: theme.palette.secondary.main
  }
}))

export default useStyles
